import api from 'api'
import { CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST } from 'api/cacheTagTypes'

import Constants from 'Constants'

const { SERVER_PAYMENTS_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getPGUserInfo: builder.query({
      // Omitting accountId falls back to the tenant-level connector instead of the unit's.
      query: ({ accountId } = {}) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/user/info`,
        method: 'POST',
        body: accountId ? { accountId } : {},
      }),
    }),
    getIsSurchargeApplied: builder.query({
      query: () => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/payment/surcharge`,
        method: 'GET',
      }),
    }),
    getSurchargeRate: builder.query({
      query: ({ zip, token, accountId }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/payment/surcharge/rate`,
        method: 'GET',
        // Token is required: Fortis returns surcharge_applied=false without one, and the response
        // is intentionally not cached on the backend (per-token correctness over hit rate).
        params: { zip, ...(token ? { token } : {}), ...(accountId ? { accountId } : {}) },
      }),
    }),
    getAllPaymentMethods: builder.query({
      query: ({ accountId }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/payment-method/list`,
        method: 'POST',
        body: { accountId },
      }),
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST,
        { type: CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST, id: accountId },
      ],
    }),
    addPaymentMethod: builder.mutation({
      query: ({ payload }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/payment-method/add`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, error, { payload }) => [{ type: CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST, id: payload.accountId }],
    }),
    removePaymentMethod: builder.mutation({
      query: ({ payload }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/payment-method/remove`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, error, { payload }) => [{ type: CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST, id: payload.accountId }],
    }),
    toggleAutoPay: builder.mutation({
      query: ({ payload }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/toggle-autopay`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, error, { payload }) => [{ type: CACHE_TAG_ACCOUNT_PAYMENT_METHOD_LIST, id: payload.accountId }],
    }),
  }),
})

export const {
  useGetPGUserInfoQuery,
  useLazyGetPGUserInfoQuery,
  useLazyGetIsSurchargeAppliedQuery,
  useLazyGetSurchargeRateQuery,
  useLazyGetAllPaymentMethodsQuery,
  useAddPaymentMethodMutation,
  useRemovePaymentMethodMutation,
  useToggleAutoPayMutation,
} = extendedApi

export const getPGUserInfoSlice = extendedApi.endpoints.getPGUserInfo.select()
